// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import '@/styles/index.scss';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';
import VuejsDialog from 'vuejs-dialog';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.use(VuejsDialog);
Vue.use(VueAwesomeSwiper /* { default global options } */);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js